/*
创建者 程楠
推荐商品
*/
<template>
  <div class="squares" style="text-align:left;">
    <ul class="list_pic clearfix">
      <li class="item" v-for="item in goods" :key="item.goodsId">
        <div class="goods-content-v2">
          <div class="goods-pic">
            <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
              <img :src="item.thumbnail" :alt="item.name"/>
            </router-link>
            <span class="goods-pic-tag" v-bind:style="{color: item.topBgcolor}">{{ item.topRightContent }}</span>
          </div>
          <div class="goods-info">
            <div v-if="item.name" class="goods-name">
              <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank">
                <span v-html="item.name"></span>
              </router-link>
            </div>
            <div v-if="item.bottomContent" class="goods-bottom-content">
              <span v-bind:style="{color: item.bottomBgcolor}" v-html="item.bottomContent"></span>
            </div>
            <div class="goods-price" v-if="item.price">
              <em class="sale-price" :title="'原价：¥'+item.mktPrice">¥{{item.price}}</em>
            </div>
            <!-- <div class="goods-price" v-if="item.price">
              <em class="sale-price" :title="'抵后价：¥'+item.mktprice">抵后价：¥{{item.price}}</em>
            </div> -->
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: ["data"],
    directives: {},
    data() {
      return {
        goods: []
      }
    },
    watch: {
      data: function (newVal, oldVal) {
        this.goods = newVal.map(v => {
          if (!v.goodsId) {
            return {...v, goodsId: v.goodsId || v.goods_id};
          }
          return v;
        });
      }
    },
    computed: {},
    methods: {}
  }

</script>



// WEBPACK FOOTER //
// module-recommend-goods.vue?9d731af4